import React, { useEffect, useState } from "react";
import { GetMaterials } from "../../hooks/useServiceData";
import { MaterialTableHeadCells } from "../../constants/MaterialConstants";
import GeneralTable from "../GeneralTable";

export const MaterialTable = (props) => {
  const [materials, setMaterials] = useState([]);

  const { data } = GetMaterials();

  useEffect(() => {
    let materialList = [];

    if (data?.data) {
      materialList = data?.data.map((material) => {
        return {
          id: material.id,
          owner_id: material.owner_id,
          name: material.name,
          cost: material.cost,
          account: material.account.number,
          isActive: material.isActive === 1 ? "Aktiv" : "Inaktiv",
        };
      });
      setMaterials(materialList);
    }
  }, [data]);

  return (
    <>
      <GeneralTable
        headCells={MaterialTableHeadCells}
        rows={materials}
        handleSelect={props.handleSelect}
      />
    </>
  );
};
